import { AgentPromptDocumentTab } from "@/features/agents/agent-prompt-document-tab";
import { AGENT_INSTRUCTIONS_PROMPT_KEY } from "@/lib/types/control-plane-agents";

export function AgentInstructionsTab() {
  return (
    <AgentPromptDocumentTab
      tabId="instructions"
      promptKey={AGENT_INSTRUCTIONS_PROMPT_KEY}
      title="AGENTS.md"
      placeholder="Write the agent instructions markdown..."
    />
  );
}
